/* eslint-disable import/prefer-default-export */

// Pattern for detecting "YYYY-MM-DD"
export const YYYYMMDD = /^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/;

// Pattern for detecting "YYYY-MM-DD", as a string
export const YYYYMMDDAsString: string = "/^d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/";

export const POSTAL_CODE_PATTERN = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

export const PHONE_NUMBER_PATTERN = /^1?[-. ]?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

// https://stackoverflow.com/questions/20856197/remove-non-ascii-character-in-string
export const NON_ASCII = /[^\x00-\x7F]/g;

export const arrayToPattern = (a: any[]): RegExp => {
  return new RegExp(`(${a.join("|")})`);
};
